import { SelectedWorkspaceCtx } from "../../contexts/SelectedWorkspaceCtx";
import { WorkspaceType } from "../../stores/workspaceStore";
import { router } from "../../router";
import { addToast } from "../../toasts";

export function WorkspaceDropdownItem() {
  const { selectedWorkspace } = SelectedWorkspaceCtx;
  let thisWorkspace: WorkspaceType | null = null;
  let $ddItem: HTMLElement | null = null;

  function init() {
    if (!thisWorkspace) {
      console.error("No workspace initialized for workspace DD item!");
      return;
    }
    // Prevent duplicate event listeners when component re-renders
    const elementId = `${thisWorkspace.unique_workspace_id}-dd-item`;
    $ddItem = document.getElementById(elementId) as HTMLElement;
    
    if ($ddItem) {
      const newElement = $ddItem.cloneNode(true);
      if ($ddItem.parentNode) {
        $ddItem.parentNode.replaceChild(newElement, $ddItem);
        $ddItem = newElement as HTMLElement;
      }
      
      $ddItem.addEventListener("click", function () {
        SelectedWorkspaceCtx.setSelectedWorkspace(thisWorkspace);
        addToast({ toastBody: `👏 You are in ${thisWorkspace!.name}` }, "default", "success");
        router.navigate("/feedbox");
        window.scrollTo(0, 0);
      });
    }
  }

  function render(workspace: WorkspaceType) {
    thisWorkspace = workspace;

    return /*html*/`
    <button id="${workspace.unique_workspace_id}-dd-item" class="group py-2 px-3 block w-full text-start ${workspace.unique_workspace_id === selectedWorkspace?.unique_workspace_id ? "bg-gray-100 dark:bg-neutral-800" : "hover:bg-gray-100 hover:dark:bg-neutral-800"} rounded-lg disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100  dark:focus:bg-neutral-800">
      <div class="flex gap-x-2">
        <div
          class="size-8 min-w-[32px] shrink-0 overflow-hidden rounded-full border group-hover:border-gray-200 dark:group-hover:border-neutral-700 border-1 border-gray-100 dark:border-neutral-700 flex items-center justify-center text-white dark:bg-neutral-900">
          ${workspace.logo_url ? `<img class="object-cover w-auto h-auto max-w-full max-h-[32px]"
            src="${workspace.logo_url}"
            alt="Avatar">` : `<div class="size-8 min-w-[32px] rounded-full border border-1 border-gray-100 dark:border-neutral-700 bg-[#6172f3] flex items-center justify-center">
            <span class="text-white text-lg uppercase">${workspace.name[0]}</span>
          </div>`}
        </div>
        <div class="grow truncate w-[calc(100%-42px)]" title="${workspace.name}">
          <p class="text-sm font-medium text-gray-800 dark:text-neutral-200 truncate">
            ${workspace.name}
          </p>
          <p class="text-xs text-gray-500 dark:text-neutral-500 truncate">
          ${thisWorkspace ? thisWorkspace.domain ?? "No Custom Domain" : "No Custom Domain"}
          </p>
        </div>
        ${workspace.unique_workspace_id === selectedWorkspace?.unique_workspace_id ? `<div class="ms-auto self-center">
          <svg class="shrink-0 size-4 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>` : ""}
      </div>
    </button>
    `;
  }

  return { render, init };
}